import React, { useState, useEffect, useCallback } from 'react';
import { Input, CustomInput } from 'reactstrap';

export const Filter = ({ column, onRemoteFilterChange }) => {
  return (
    <div style={{ marginTop: 5 }}>
      {column.canFilter ? column.filterRemote ? <FilterRemote column={column} onRemoteFilterChange={onRemoteFilterChange} /> : column.render('Filter') : ""}
    </div>
  );
};

export const DefaultColumnFilter = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`Buscar (${length}) ...`}
    />
  );
};

export const FilterRemote = ({ column, onRemoteFilterChange }) => {
  const [inputValue, setInputValue] = useState('');
  const [timeoutId, setTimeoutId] = useState(null);

  const debouncedSearch = useCallback((value) => {
    // Limpiar el timeout anterior si existe
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Establecer un nuevo timeout
    const newTimeoutId = setTimeout(() => {
      onRemoteFilterChange(column, value);
      setTimeoutId(null); // Limpiar la referencia del timeout
    }, 3000);

    setTimeoutId(newTimeoutId);
  }, [column, onRemoteFilterChange, timeoutId]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedSearch(value);
  };

  // Limpiar timeout al desmontar el componente
  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  return (
    <Input
      value={inputValue}
      onChange={handleInputChange}
      placeholder={`Buscar...`}
    />
  );
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      id='custom-select'
      className="form-select"
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value=''>All</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};
